// extracted by mini-css-extract-plugin
export var childrenContainer = "_1a-0";
export var virtualScrollArea = "_1a-1";